import { environment } from '@env/environment';
export class AppConfig {
   public apiUrl = environment.apiUrl;
   public apiAuthUrl = environment.apiAuthUrl;
   public apiS3PaymentUrl = environment.s3PaymentUrl;
   public apiS3DocumentUrl = environment.s3DocumentUrl;
   // public apiUrl = 'https://testroamingse.new-backend.trackwalkins.com/v1/roamingse/';
  // public apiAuthUrl= 'https://testroamingse.new-backend.trackwalkins.com/auth/roamingse/';
};





// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/app.config.ts